import React from 'react';
import { TableRow, TableCell } from '@mui/material';
import CommentEdit from '../CommentEdit';

const CommentsTableRow = ({
  commentId,
  createdDate = '',
  contactName = '',
  comment = '',
  onClickEdit = null,
  onClickDelete = null,
  formatDate = null,
  updateComment = null,
  item = {},
}) => (
  <TableRow key={'list' + commentId} id={commentId}>
    <TableCell name="createdDate">{formatDate(createdDate)}</TableCell>
    <TableCell name="contactName">{contactName}</TableCell>
    <CommentEdit
      toggleEditState={onClickEdit}
      updateComment={updateComment}
      item={item}
      comment={comment}
      onClickDelete={onClickDelete}
      commentId={commentId}
    />
  </TableRow>
);

export default CommentsTableRow;
